import LyInput from './src/index.vue'

LyInput.install = function (Vue) {
    Vue.component(LyInput.name, LyInput)
}

export default LyInput



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/input/index.js
// module id = null
// module chunks = 